<div class="modal-container">
  <div class="title">
    <h2 style="margin-top: 10px">Reason For Decline</h2>
    <button mat-icon-button [mat-dialog-close] aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="content">
    <span>{{ data?.declineReason }}</span>
    <span style="font-style: italic"
      >Declined on {{ data?.updateDate | date: 'mediumDate' }}</span
    >
  </div>
</div>
